<!-- 
 * @description: 顶部导航模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-21 17:13:52
!-->
<template>
  <div>
    <div
      :class="
        this.$Base.checkSysteam() == 'MOBILE' ? 'mRastarNav' : 'RastarNav'
      "
      v-if="!isForgot && !isMailbox && !isPhone && !isVerified"
    >
      <ul class="nav nav-1">
        <li
          @click="(searId = 2), changeNavMai(2)"
          :class="{ active: searId == 2 }"
        >
          {{ $t("message.navigator_lang") }}
        </li>
        <li
          v-on:click="(searId = 1), changeNavMai(1)"
          v-bind:class="{ active: searId == 1 }"
        >
          {{ $t("message.navigator_signIn") }}
        </li>
      </ul>
      <!-- 登陆  
        v-on:mailbox="mailbox"
        v-on:forgot="forgot"
        v-on:phone="phone"-->
      <rastar-login
        :getCodeShow="getCodeShow"
        :isForgot="isForgot"
        :isMailbox="isMailbox"
        :appId="appId"
        :pId="pId"
        :mdId="mdId"
        :ukey="ukey"
        :initialization="initialization"
        :system="system"
        v-if="searId == 2"
        v-on="{
          forgot: forgot,
          mailbox: mailbox,
          phoneB: phoneB,
          loginSuccess: loginSuccess,
        }"
      ></rastar-login>
      <!-- 登陆 end -->

      <!-- 注册 -->
      <rastar-register
        v-if="searId == 1"
        :getCodeShow="getCodeShow"
        :appId="appId"
        :pId="pId"
        :mdId="mdId"
        :ukey="ukey"
        :msgVal="msgVal"
        :initialization="initialization"
        :system="system"
        v-on="{
          loginSuccess: loginSuccess,
        }"
      ></rastar-register>
    </div>

    <!-- 忘记密码 -->
    <rastar-forgot
      v-if="isForgot"
      :getCodeShow="getCodeShow"
      :appId="appId"
      :pId="pId"
      :mdId="mdId"
      :ukey="ukey"
      :system="system"
      v-on:forgot="forgot"
    ></rastar-forgot>

    <!-- 邮箱登陆 -->
    <rastar-mailbox
      v-if="isMailbox"
      :getCodeShow="getCodeShow"
      :appId="appId"
      :pId="pId"
      :mdId="mdId"
      :ukey="ukey"
      :system="system"
      v-on="{
          loginSuccess: loginSuccess,
          mailbox: mailbox,
        }"
    ></rastar-mailbox>

    <!-- 手机登陆 -->
    <rastar-phone
      v-if="isPhone"
      :getCodeShow="getCodeShow"
      :appId="appId"
      :pId="pId"
      :mdId="mdId"
      :ukey="ukey"
      :system="system"
      v-on="{
          loginSuccess: loginSuccess,
          phoneB: phoneB,
      }"
    ></rastar-phone>
    <!-- 手机登陆 end -->

    <!-- 实名验证弹窗 -->
    <rastar-verified
      v-if="isVerified"
      :appId="appId"
      :pId="pId"
      :mdId="mdId"
      :ukey="ukey"
      :system="system"
      :uinfo="uinfo"
      v-on:finish="verifiedFinish"
    ></rastar-verified>

    <!-- 提示弹窗 -->
    <div :class="
        this.$Base.checkSysteam() == 'MOBILE' ? 'mRastarTips' : 'RastarTips'
      " v-if="showTips">
      <div class="tips-mask"></div>
      <div class="tips-dialog">
        <div class="tips-title">{{ $t("message.tips") }}</div>
        <div class="tips-content">{{ tips }}</div>
        <div class="tips-btn" @click="showTips = false">{{ $t("message.confirm") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import rastarRegister from "./../register/template.vue";
import rastarLogin from "../land/template.vue";
import rastarForgot from "./../forgot/template.vue";
import rastarMailbox from "./../mailbox/template.vue";
import rastarPhone from "../phone/template.vue";
import rastarVerified from "../../components/verified/template.vue"

export default {
  name: "RastarNav",
  props: [
    "appId",
    "pId",
    "mdId",
    "ukey",
    "msgVal",
    "initialization",
    "system",
    "getCodeShow",
  ],
  components: {
    rastarRegister,
    rastarLogin,
    rastarForgot,
    rastarMailbox,
    rastarPhone,
    rastarVerified
  },
  data: function () {
    return {
      isForgot: false,
      isMailbox: false,
      isPhone: false,
      isShow: false,
      isVerified: false,
      showTips: false,
      // 默认注册显示
      Index: 1,
      searId: 1,
      flag: 0,
      step: 0,

      uinfo: '',
      // 登录成功参数
      res: {},
      tips: '',
    };
  },
  methods: {
    sendCodeShow() {
      this.getCodeShow(this.name);
    },
    forgot(val) {
      this.isForgot = val;
    },
    mailbox(val) {
      this.isMailbox = val;
    },
    phoneB(val) {
      this.isPhone = val;
    },
    /**
     * 登录成功回调
     */
    loginSuccess(res) {
      this.res = res
      // 页游实名认证规则
      if(res.data.id_card){
        this.uinfo = res.data.id_card
        let id_card_info = JSON.parse(this.$Ciphertext.Decrypt(res.data.id_card))
        // status 1 开启实名 
        if(id_card_info.state == 1 ){
          // 是否未实名
          if(id_card_info.certification_state == 0){
            // 开启实名页面 (其实蛮多条件是重复状态)
            if(id_card_info?.id_config?.certification_popup_show){
              // 中断登录 开启实名页面
              this.isVerified = true
              return 
            }
          }else{
            // 是否未成年
            if(id_card_info.is_underage){
              // 是否开启限制未成年登录
              if(id_card_info?.id_config?.limit_underage_state && id_card_info?.id_config?.underage_popup_show){
                // 显示未成年未满18岁弹窗 并且中断登录
                this.showTips = true
                this.tips = this.$t("message.verifiedTips1")
                return
              }
            }
          }
        }
      }
      this.loginSuccessJump()
    },

    // 实名结束回调
    verifiedFinish(res){
      if(res.type == 'cancel'){
        this.isVerified = false
        this.showTips = true
        this.tips = this.$t("message.verifiedTips2")
      }else if(res.type == 'jump'){
        this.isVerified = false
        // 允许跳过
       this.loginSuccessJump()
      }else if(res.type == 'success'){
        // 实名成功
        if(res.data.state == 1){
          // 是否未成年
          if(res.data.is_underage){
            // 是否现在未成年登录并且弹窗
            if(res.data?.id_config?.limit_underage_state == 1 && res.data?.id_config?.underage_popup_show){
              // 弹窗
              this.isVerified = false
              this.showTips = true
              this.tips = this.$t("message.verifiedTips1")
              return 
            }
          }
          this.isVerified = false
          this.loginSuccessJump()
        }
      }
    },
    // 登录成功执行跳转
    loginSuccessJump(res = this.res){
      this.$Storage.localStorageSet("show", res.data.email_bind_show);
      this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
      this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
      this.$Storage.localStorageSet(
        "access_token",
        res.data.access_token
      );
      // 登陆成功埋点
      if(res.data.user_login_type == 0){
        // 标识是新注册进来的
        this.$Storage.localStorageSet("regId", 1);
        // 注册成功埋点
        if (this.system === "pc") {
          this.$Report.webDotFather(this.pId, this.appId, this.ukey, "signup_pcldy_success");
        } else {
          this.$Report.webDotFather(this.pId, this.appId, this.ukey, "signup_moldy_success");
        }
      }else{
        if (this.system === "PC") {
          this.$Report.webDotFather(this.pId, this.appId, this.ukey, "login_pcldy_password_success");
        } else {
          this.$Report.webDotFather(this.pId, this.appId, this.ukey, "login_moldy_password_success");
        }
      }
      
      // 登陆成功了跳转页面
      window.location.href = `/web?ukey=${this.ukey}&appid=${this.appId}&pid=${this.pId}&md_id=${this.mdId}`;
    },

    /*
     *@description: 触发埋点上报
     *@author: 薛微微
     *@date: 2023-06-21 17:22:23
     */
    changeNavMai(k) {
      if (k == 1) {
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_pcldy_signup_index"
          );
        } else {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_moldy_signup_index"
          );
        }
      } else {
        if (this.system === "PC") {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_pcldy_password_login_index"
          );
        } else {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_moldy_password_login_index"
          );
        }
      }
    },
  },
  created() {
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
